import { render, staticRenderFns } from "./ReferenceDetail.vue?vue&type=template&id=61650b24&scoped=true"
import script from "./ReferenceDetail.vue?vue&type=script&lang=js"
export * from "./ReferenceDetail.vue?vue&type=script&lang=js"
import style0 from "./ReferenceDetail.vue?vue&type=style&index=0&id=61650b24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61650b24",
  null
  
)

export default component.exports